import { lazy } from "react";
import type { RouteObject } from "react-router";

const DashboardPage = lazy(() => import("./views/dashboard"));

const dashboard2Routes: RouteObject = {
  id: "dashboard-2",
  path: "/dashboard-2",
  element: <DashboardPage />,
};

export default dashboard2Routes;
